/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== 'production';

export const logDebug = (...args) => {
  if (isDev) {
    console.debug(...args);
  }
};

export const logError = (...args) => {
  if (isDev) {
    console.error(...args);
  }
};
